import axios from "axios";
import signRequest from "./signRequest";

const proxyURL = process.env.REACT_APP_baseURL + "/proxy";
const apiKey = process.env.REACT_APP_apiKey; /* User API Key */
const apiSecret = process.env.REACT_APP_apiSecret; /* User API Secret */

const getTickerByCrypto = async (cryptoName) => {
    try {
        const method = "public/get-ticker?instrument_name=" + cryptoName;
        const url = new URL(proxyURL);
        url.searchParams.set("method", method);
        // console.log(url);
        const res = await axios.get(url);
        const data = res.data.data;
        return data;
    } catch (error) {
        console.log(error);
        return {};
    }
};

const createOrders = async (instrument_name, side, price, quantity) => {
    try {
        let request = {
            id: 88,
            method: "private/create-order",
            params: {
                instrument_name: instrument_name,
                side: side,
                type: "LIMIT",
                price: price,
                quantity: quantity,
                //client_oid: "my_order_8888",
                client_oid: new Date().getTime(),
                time_in_force: "GOOD_TILL_CANCEL",
                exec_inst: "POST_ONLY",
            },
            nonce: new Date().getTime(),
        };
        let requestBody = JSON.stringify(
            signRequest(request, apiKey, apiSecret)
        );
        //console.log(requestBody);
        const res = await axios.post(proxyURL, requestBody, {
            headers: { "Content-Type": "application/json" },
        });
        // console.log(res);
        const data = res.data;
        // console.log(data);
        return data;
    } catch (error) {
        console.log(error);
        return {};
    }
};

const cancelOrders = async (order_id, instrument_name) => {
    try {
        let request = {
            id: 88,
            method: "private/cancel-order",
            params: {
                instrument_name: instrument_name,
                order_id: order_id,
            },
            nonce: new Date().getTime(),
        };
        let requestBody = JSON.stringify(
            signRequest(request, apiKey, apiSecret)
        );
        const res = await axios.post(proxyURL, requestBody, {
            headers: { "Content-Type": "application/json" },
        });
        // console.log(res);
        const data = res.data;
        // console.log(data);
        return data;
    } catch (error) {
        console.log(error);
        return {};
    }
};

const getOrderDetails = async (order_id) => {
    try {
        let request = {
            id: 88,
            method: "private/get-order-detail",
            params: {
                order_id: order_id,
            },
            nonce: new Date().getTime(),
        };
        let requestBody = JSON.stringify(
            signRequest(request, apiKey, apiSecret)
        );
        const res = await axios.post(proxyURL, requestBody, {
            headers: { "Content-Type": "application/json" },
        });
        const data = res.data.order_info;
        // console.log(data);
        return data;
    } catch (error) {
        console.log(error);
        return {};
    }
};

const getOpenOrders = async (name = null) => {
    // console.log(apiKey, apiSecret);
    try {
        let request = {
            id: 88,
            method: "private/get-open-orders",
            params: {
                page_size: 200,
                page: 0,
            },
            nonce: new Date().getTime(),
        };
        if (name !== null) request.params.instrument_name = name;
        let requestBody = JSON.stringify(
            signRequest(request, apiKey, apiSecret)
        );
        // console.log(requestBody);
        const res = await axios.post(proxyURL, requestBody, {
            headers: { "Content-Type": "application/json" },
        });
        const data = res.data.order_list;
        return data;
    } catch (error) {
        console.log(error);
        return {};
    }
};

const getAccountSummaryByCrypto = async (crypto) => {
    try {
        // console.log("Get Account Summary");
        const cryptoUpperCase = crypto.toUpperCase();
        let request = {
            id: 88,
            method: "private/get-account-summary",
            params: { currency: cryptoUpperCase },
            nonce: new Date().getTime(),
        };
        let requestBody = JSON.stringify(
            signRequest(request, apiKey, apiSecret)
        );
        console.log(requestBody);
        const res = await axios.post(proxyURL, requestBody, {
            headers: { "Content-Type": "application/json" },
        });
        const data = res.data.accounts[0];
        return data;
    } catch (error) {
        console.log(error);
        return {};
    }
};

export {
    getTickerByCrypto,
    getOpenOrders,
    getOrderDetails,
    getAccountSummaryByCrypto,
    cancelOrders,
    createOrders,
};

// module.exports = {
//     getTickerByCrypto,
//     getOpenOrders,
//     getAccountSummaryByCrypto,
// };
